import $axios from '@/store/axios-instance.js';

export default {
    state: {
        executorDictionaryList: null,
        executorServiceList: null,
        currentExecutorService: null,
    },
    mutations: {
        retrieveExecutorDictionaryList(state, payload){
            state.executorDictionaryList = payload
        },
        retrieveExecutorServiceList(state, payload){
            state.executorServiceList = payload
        },
        executorServiceJoin(state, payload){
            if(!state.executorServiceList){
                return
            }
            let service = state.executorServiceList.services.find(item => item.id === payload)
            if(!service.executorsCnt)
            {
                service.executorsCnt = 0
            }
            service.executorsCnt += 1
        },
        retrieveExecutorService(state, payload) {
            state.currentExecutorService = payload
        },
        executorServicePushUp(state, payload){
            let oldIndex = state.executorServiceList.services.findIndex(item => item.id === payload.service.id)
            if(oldIndex > -1) {
                state.executorServiceList.services.splice(0, 0, state.executorServiceList.services.splice(oldIndex, 1)[0]);
                Object.assign(state.executorServiceList.services[0], payload.service);
            } else if (payload.inFilter){
                state.executorServiceList.services.unshift(payload.service)
                state.executorServiceList.serviceCount += 1
            }
        },
        executorOpenService(state, payload){
            let entity = state.executorServiceList.services.find(item => item.id === payload)
            entity.isUnread = false
        }
    },
    actions: {
        retrieveExecutorDictionaryList(context){
            return new Promise((resolve, reject) => {
                $axios
                    .get('executors/dictList')
                    .then(response => {
                        context.commit('retrieveExecutorDictionaryList', response.data)

                        resolve(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        retrieveExecutorServiceList(context, payload){
            return new Promise((resolve, reject) => {
                $axios
                    .get('executor/services', {
                        params: payload
                    })
                    .then(response => {
                        context.commit('retrieveExecutorServiceList', response.data)

                        resolve()
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        retrieveExecutorService(context, payload){
            return new Promise((resolve, reject) => {
                if(!payload){
                    context.commit('retrieveExecutorService', null)
                    resolve()
                } else {
                    $axios
                        .get(`executor/services/${payload}`)
                        .then(response => {
                            context.commit('retrieveExecutorService', response.data)

                            resolve(response.data)
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                }
            })
        },
        executorServiceJoin(context, payload){
            return new Promise((resolve, reject) => {
                $axios
                    .post(`executor/services/${payload}/join`)
                    .then(() => {
                        context.commit('executorServiceJoin', payload)

                        resolve()
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        executorServicePushUp(context, payload){
            context.commit('executorServicePushUp', payload)
        },
        executorOpenService(context, payload){
            return new Promise((resolve) => {
                context.commit('executorOpenService', payload)
                context.commit('removeServiceChangedMessage', payload)
                resolve()
            })
        },
    },
    getters: {
        executorDictionaryList(state){
            return state.executorDictionaryList ? state.executorDictionaryList.sort(function(a, b){
                if (a.name > b.name) {
                    return 1;
                }
                if (a.name < b.name) {
                    return -1;
                }
                return 0;
            }) : []
        },
        executorServiceList(state){
            return state.executorServiceList ? state.executorServiceList.services : []
        },
        executorServiceListTotal(state){
            return state.executorServiceList ? state.executorServiceList.serviceCount : 0
        },
        currentExecutorService(state){
            return state.currentExecutorService
        }
    }
}